// extracted by mini-css-extract-plugin
export default {"authMainConatiner":"AuthLayout_authMainConatiner__maBjQ"};